export const formatPhoneNumber = (phoneNumberString) => {
  const cleaned = (`${phoneNumberString}`).replace(/\D/g, '')
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    return `${match[1]}-${match[2]}-${match[3]}`
  }
  return null
}

/**
  `maskPhone` takes a phone number without any special characters (999999999) and returns
  a formatted version (999-999-9999)
*/
export const maskPhone = (s: string): string => {
  let sCopy = s.replace(/-/g, '').slice(0, 10)
  if (sCopy.length > 6) {
    sCopy = [sCopy.slice(0, 3), '-', sCopy.slice(3, 6), '-', sCopy.slice(6)].join('')
    return sCopy
  }
  if (sCopy.length > 3) {
    sCopy = [sCopy.slice(0, 3), '-', sCopy.slice(3)].join('')
    return sCopy
  }
  return sCopy
}
